<template>
  <div id="adminDetalleReposicion" :data-ready="printReady">
      <v-toolbar>
        <img src="@/assets/logo_javer.png" height="60" width="auto">
        <v-spacer></v-spacer>
        <v-toolbar-title>Detalle de reposición fondo fijo de caja</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6>
              <v-container>
                <h3 class="grey--text">GENERAL</h3><br/>
                <v-radio-group v-model="detalle.reposicion.general.tipo_solicitud">
                  <div slot="label"><strong>Tipo de solicitud</strong></div>
                  <v-radio label="Cheque" color="primary" value="cheque"></v-radio>
                  <v-radio label="Depósito electrónico" color="primary" value="deposito_electronico"></v-radio>
                </v-radio-group>
                <v-radio-group v-model="detalle.reposicion.general.tipo_pago">
                  <div slot="label"><strong>Tipo de pago</strong></div>
                  <v-radio label="Gastos comprobables" color="primary" value="gastos_comprobables"></v-radio>
                  <v-radio label="Otros" color="primary" value="otros"></v-radio>
                </v-radio-group><br/>
                <v-text-field v-model="detalle.reposicion.solicitud.monto" prefix="$" suffix="MXN" label="Fondo fijo autorizado"></v-text-field>
                <br/>
                <template v-if="detalle.reposicion.general.tipo_solicitud === 'deposito_electronico'">
                  <h3 class="grey--text">DATOS DE DEPÓSITO</h3><br/>
                  <v-text-field v-model="detalle.reposicion.general.banco" label="Banco"></v-text-field>
                  <v-text-field v-model="detalle.reposicion.general.cuenta" label="No. Cuenta"></v-text-field>
                  <v-text-field v-model="detalle.reposicion.general.tarjeta" label="No. Tarjeta"></v-text-field>
                  <v-text-field v-model="detalle.reposicion.general.clabe" label="Referencia interbancaria"></v-text-field><br/>
                </template>
                <h3 class="grey--text">FIRMAS</h3><br/>
                <v-list three-line>
                  <template v-for="(item, i) in detalle.reposicion.firmas">
                    <v-list-tile class="pb-2 pt-2">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                        <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                        <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'" v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-show="(i + 1) < detalle.reposicion.firmas.length"></v-divider>
                  </template>
                </v-list>
              </v-container>
            </v-flex>
            <v-flex xs6>
              <v-container>
                <h3 class="grey--text">DATOS DE CAJA CHICA</h3><br/>
                <v-text-field v-model="detalle.reposicion.solicitud.empresa" label="Empresa"></v-text-field>
                <br/>
                <h3 class="grey--text">DATOS DEL SOLICITANTE</h3><br/>
                <v-text-field v-model="detalle.reposicion.usuario.unidad" label="Unidad de negocio"></v-text-field>
                <v-text-field v-model="detalle.reposicion.usuario.plaza" label="Plaza"></v-text-field>
                <v-text-field v-model="detalle.reposicion.solicitud.centro" label="Centro de costos"></v-text-field>
                <v-text-field v-model="detalle.reposicion.usuario.beneficiario" label="Beneficiario"></v-text-field>
                <br/>
                <h3 class="grey--text">FACTURAS</h3><br/>
                <v-text-field v-model="detalle.reposicion.resumen.no_facturas" class="pt-3" label="No. Facturas"></v-text-field>
                <v-text-field v-model="detalle.reposicion.resumen.subtotal" label="Subtotal" prefix="$" suffix="MXN"></v-text-field>
                <v-text-field v-model="detalle.reposicion.resumen.iva" label="IVA" prefix="$" suffix="MXN"></v-text-field>
                <v-text-field v-model="detalle.reposicion.general.importe_total" label="Importe por reembolsar" prefix="$" suffix="MXN"></v-text-field>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
  </div>
</template>

<script>
import axios from 'axios'
import services from '@/config/services'
import printReady from '@/utils/printReady'

export default {
  name: 'adminDetalleReposicion',
  mixins: [printReady],
  data: () => ({
    loading: false,
    detalle: {
      reposicion: {
        solicitud: {
          monto: 0,
          empresa: '',
          centro: ''
        },
        usuario: {
          unidad: '',
          plaza: '',
          beneficiario: ''
        },
        general: {
          tipo_solicitud: null,
          tipo_pago: null,
          monto: '',
          banco: '',
          cuenta: '',
          tarjeta: '',
          clabe: '',
          importe_total: ''
        },
        facturas: [],
        resumen: {
          no_facturas: 0,
          subtotal: 0,
          iva: 0
        },
        firmas: [],
        detalle_factura: {
          index: '',
          tipo_gasto: null,
          pdf: { nombre: '', data: null },
          xml: { nombre: '', data: null },
          foto: { nombre: '', data: null },
          concepto: '',
          razon_social: '',
          rfc: '',
          no_factura: '',
          proveedor_frontera: false,
          importe: '',
          iva: '',
          total: ''
        }
      },
    }
  }),
  mounted() {
    var token = this.getQueryVariable('token')
    var id = this.getQueryVariable('id')
    this.$session.start()
    this.$session.set('jwt', token)
    this.showDetailRep(id);
  },
  methods: {
    ws(method, name, data) {
      if (method === 'get') {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          let params = ''
          for (let k in data) {
            params += k + '=' + data[k] + '&'
          }
          params = (params !== '') ? '?' + params : ''
          return axios.get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
      else {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          return axios.post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1)
      var vars = query.split("&")
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=")
        if (pair[0] == variable){
          return pair[1]
        }
      }
      return(false);
    },
    prepareDetailRep(data) {
      this.detalle.reposicion.solicitud.monto = data.solicitud.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.reposicion.solicitud.empresa = data.solicitud.empresa
      this.detalle.reposicion.solicitud.centro = data.solicitud.centro
      this.detalle.reposicion.usuario.unidad = data.usuario.unidad
      this.detalle.reposicion.usuario.plaza = data.usuario.plaza
      this.detalle.reposicion.usuario.beneficiario = data.usuario.nombre
      this.detalle.reposicion.general.tipo_solicitud = data.reposicion.tipo_solicitud
      this.detalle.reposicion.general.tipo_pago = data.reposicion.tipo_pago
      this.detalle.reposicion.general.banco = data.reposicion.banco
      this.detalle.reposicion.general.cuenta = data.reposicion.cuenta
      this.detalle.reposicion.general.tarjeta = data.reposicion.tarjeta
      this.detalle.reposicion.general.clabe = data.reposicion.clabe
      this.detalle.reposicion.general.importe_total = data.reposicion.importe_total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.reposicion.facturas = data.facturas
      this.detalle.reposicion.resumen.no_facturas = data.facturas.length
      let subtotal = 0
      let iva = 0
      for (let i = 0; i < data.facturas.length; i++) {
        subtotal += parseFloat(parseFloat(data.facturas[i].importe).toFixed(2))
        iva += parseFloat(parseFloat(data.facturas[i].iva).toFixed(2))
      }
      this.detalle.reposicion.resumen.subtotal = subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.reposicion.resumen.iva = iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.reposicion.firmas = data.firmas
      this.dialogDetRep = true
    },
    showDetailRep(id) {
      this.loading = true
      this.ws('get', 'adminDetalleReposicionCajaChica', { id })
        .then(res => {
          if (res.ok) {
            this.prepareDetailRep(res.data)
            this.markPrintReady()
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>
